import { render, staticRenderFns } from "./likeMenu.vue?vue&type=template&id=c5ddb296&scoped=true&"
import script from "./likeMenu.vue?vue&type=script&lang=js&"
export * from "./likeMenu.vue?vue&type=script&lang=js&"
import style0 from "./likeMenu.vue?vue&type=style&index=0&id=c5ddb296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ddb296",
  null
  
)

export default component.exports